import { render, staticRenderFns } from "./CustomerInvoice.vue?vue&type=template&id=897994dc&scoped=true&"
import script from "./CustomerInvoice.vue?vue&type=script&lang=js&"
export * from "./CustomerInvoice.vue?vue&type=script&lang=js&"
import style0 from "./CustomerInvoice.vue?vue&type=style&index=0&id=897994dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897994dc",
  null
  
)

export default component.exports